<template>
  <div class="TalentButtonSilder">

    <div class="silder-item" v-if="user.isLogin == true"  @click="gotoResume()">
      <div class="card animated-item">
        <img src="@/common/images/talent/common/slid (6).png" alt="slid">
        <p>我的简历</p>
        <div class="bg"></div>
      </div>
    </div>
    <!-- 登录后 -->

    <div class="silder-item" @click="setLoginPop(true)" v-if="user.isLogin == false">
      <div class="card animated-item">
        <img src="@/common/images/talent/common/slid (2).png" alt="slid">
        <p>求职登录</p>
        <div class="bg"></div>
      </div>
    </div>
    <!-- 登录前 -->

    <div class="silder-item" @click="gotoSearch">
      <div class="card animated-item">
        <img src="@/common/images/talent/common/slid (3).png" alt="slid">
        <p>职位列表</p>
        <div class="bg"></div>
      </div>
    </div>
    <div class="silder-item">
      <div class="card animated-item">
        <img src="@/common/images/talent/common/slid (1).png" alt="slid">
        <p class="otxt">我要招聘</p>
        <p class="ttxt">扫一扫添加</p>
        <div class="bg"></div>
      </div>
      <div class="qrcode animated fadeInRight">
       <img src="@/common/images/talent/common/qrcode.png" alt="slid">
      </div>
    </div>
    <div class="silder-item">
      <div class="card animated-item">
        <img src="@/common/images/talent/common/slid (5).png" alt="slid">
        <p class="otxt">咨询热线</p>
        <p class="ttxt">0755-86393108</p>
        <div class="bg"></div>
      </div>
      
      
    </div>
    <div class="silder-item">
      <div class="card" @click="goto">
        <img src="@/common/images/talent/common/slid (4).png" alt="slid">
        <p>返回顶部</p>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'TalentButtonSilder',
  data () {
    return {
        isZJ178Domain:false//是否是资鲸178域名，需要屏蔽直播和资讯
    }
  },
  mounted () {      
    if(location.hostname.indexOf("zj178.com")>=0){
        this.isZJ178Domain=true
    }
  },
  methods: {
    gotoResume() {
      this.$router.push({
          name: "Resume"
        })
    },
    gotoSearch() {
        this.$router.push({
          name: "TalentSearch"
        })
      },
      goto() {
        $('html').scrollTop(0)
      },
      ...mapActions([
          'setLoading',
          'setLoginPop'
      ])
  },
  filters: {},
  watch: {},
  computed: {
    ...mapGetters([
        'user'
    ])
  },
  components: {
      
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.TalentButtonSilder {
  position: fixed;
  top: 231px;
  right: 0;
  z-index: 55;

  .silder-item {
    margin-bottom: 7px;
    position: relative;
    height: 70px;
    box-sizing: border-box;
    color: #fff;
    font-size: 12px;
    cursor: pointer;

    .card {
      position: absolute;
      right: 0;
      width: 68px;
      height: 70px;
      background:rgba(0,0,0, .4);
      border:1px solid rgba(255,255,255, 1);
    }
    .ttxt {
      display: none;
    }
    
    .qrcode {
      position: absolute;
      display: none;
      right: 164px;
      bottom: -2px;
      img {
        width: 168px;
        height: 224px;
      }
    }
    &:hover {
      .qrcode {
        display: block;
      }
    }
    
    &:hover .animated-item {
      width: 164px;
      text-align: center;
      line-height: 70px;

      img, p {
        display: inline-block;
        font-size: 14px;
      }
      img {
        margin-right: 8px;
        transform: translateY(5px);
        -ms-transform: translateY(5px);
        -moz-transform: translateY(5px);
        -o-transform: translateY(5px);
        -webkit-transform: translateY(5px);
      }
      .otxt {
        display: none;
      }
      .ttxt {
        display: inline-block;
      }
      .bg {
        position: absolute;
        top: 0;
        width: 164px;
        height: 70px;
        background: #2E7FFF;
      }
    }

    img,
    p {
      position: relative;
      z-index: 1;
    }
    img {
      display: block;
      margin: auto;
      margin-top: 15px;
      width: 20px;
      height: 20px;
    }
    p {
      margin-top: 4px;
      text-align: center;
    }
  }
  
  .animated-item {
    position: relative;
    transition: all .5s;
    -webkit-transition: all .5s;
    -ms-transition: all .5s;
    -moz-transition: all .5s;
    -o-transition: all .5s;
    overflow: hidden;
  }
}
</style>